import { Injectable } from '@angular/core';
import { RestCallService } from '../../../../core/services/rest-call/rest-call.service';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { NotificationService } from 'src/app/core/services/notification/notification.service';
import { TranslateApplicationService } from '../../../../core/translate/translate-application-service';
import { CognitoService } from 'src/app/core/services/cognito/cognito.service';
import { INDAManagement } from '../Interfaces/INDAManagement';
import { INDATypes } from '../Interfaces/INDATypes';
import { IEvidencesNDAs } from '../Interfaces/IEvidences';

@Injectable({
	providedIn: 'root',
})
export class NDAManagementService extends RestCallService {
  public dataToSend: INDAManagement = {
    pkndamanagment: 0,
    fkndamanagment: 0,
    ndamanagment: '',
    fkndatype: 0,
    ndatypename: '',
    available: false,
    creationdate: new Date,
    strcreationdate: '',
    fkemployeecreator: 0,
    lastupdated: new Date,
    strlastupdated: '',
    fkemployeeupdater: 0,
    employeecreatorname: '',
    employeeupdatername: '',
    username: '',
    fksite: 0
  };
  public dataTypeToSend: INDATypes= {
    pkndatype: 0,
    ndatype: 0,
    creationdate: new Date(),
    strcreationdate: '',
    fkemployeecreator: 0,
    lastupdated: new Date(),
    strlastupdated: '',
    fkemployeeupdater: 0,
    available: false,
    fksite: 0,
    username: ''
  };
  public dataEvidenceNDAs: IEvidencesNDAs = {
    pkevidencenda: 0,
    evidencenda: '',
    fkndamanagement: 0,
    creationdate: new Date(),
    strcreationdate: '',
    fkemployeecreator: 0,
    lastupdated: new Date(),
    strlastupdated: '',
    fkemployeeupdater: 0,
    available: false,
    username: '',
    usernamecreator: '',
    fksite: 0,
    nameinbucket: ''
  }

  constructor(
      public httpClient: HttpClient,
      private cognitoService: CognitoService,
      public toastr: ToastrService,
      public notificationService: NotificationService,
      public translate: TranslateApplicationService,
  ) {
      super(httpClient, 'JACSapi', toastr, notificationService, translate);
  }

  public GetList() {
    if (!this.cognitoService.IsAuhtenticated())
        this.cognitoService.LogOut();
    this.dataToSend.fksite = Number(localStorage.getItem('pksite'));
    return this.post<INDAManagement[]>('/api/NDAManagements/GetNDAs', this.dataToSend);
  }

  public GetAvailableProjectsNDAs() {
    if (!this.cognitoService.IsAuhtenticated())
        this.cognitoService.LogOut();
    this.dataToSend.fksite = Number(localStorage.getItem('pksite'));
    return this.post<INDAManagement[]>('/api/NDAManagements/GetAvailableProjectsNDAs', this.dataToSend);
  }

  public GetNDAsBySite() {
    if (!this.cognitoService.IsAuhtenticated())
      this.cognitoService.LogOut();
  
    this.dataToSend.fksite = Number(window.localStorage.getItem("pksite"));
    return this.post<INDAManagement[]>('/api/NDAManagements/GetNDAsBySite', this.dataToSend);
  }

  public GetNDATypes(ndatype: number) {
    if (!this.cognitoService.IsAuhtenticated())
      this.cognitoService.LogOut();
    
    this.dataTypeToSend.pkndatype = ndatype;
    this.dataTypeToSend.fksite = Number(window.localStorage.getItem("pksite"));
    return this.post<INDAManagement[]>('/api/NDAManagements/GetNDAsTypes', this.dataTypeToSend);
  }

  public CreateNDAManagement(data: any) {
    if (!this.cognitoService.IsAuhtenticated())
      this.cognitoService.LogOut();
    
    this.dataToSend.pkndamanagment = data.pkndamanagment;
    this.dataToSend.ndamanagment = data.ndamanagment;
    this.dataToSend.fkndatype = data.fkndatype;
    this.dataToSend.fksite = Number(window.localStorage.getItem('pksite'));
    
    return this.post<INDAManagement[]>('/api/NDAManagements/CreateNDAManagement', this.dataToSend);
  }

  public UpdateNDAManagement(data: any) {
    if (!this.cognitoService.IsAuhtenticated())
      this.cognitoService.LogOut();
    
    this.dataToSend.pkndamanagment = data.pkndamanagment;
    this.dataToSend.ndamanagment = data.txtndamanagment.trim();
    this.dataToSend.fkndatype = data.cbfkndatype;
    this.dataToSend.fksite = Number(window.localStorage.getItem('pksite'));
    
    return this.put('/api/NDAManagements/UpdateNDAManagement', this.dataToSend);
  }

  public CreateEvidenceNDA(data: any) {
    
    if (!this.cognitoService.IsAuhtenticated())
      this.cognitoService.LogOut();
    
    this.dataEvidenceNDAs.evidencenda = data.evidencenda;
    this.dataEvidenceNDAs.fkndamanagement = data.fkndamanagement;
    this.dataEvidenceNDAs.nameinbucket = data.nameinbucket;
    this.dataEvidenceNDAs.fksite = Number(window.localStorage.getItem('pksite'));
    
    return this.post('/api/Evidences/CreateEvidenceNDA', this.dataEvidenceNDAs);
  }
        
  public ChangeStatusNDAManagement(data: any) {
    if (!this.cognitoService.IsAuhtenticated())
      this.cognitoService.LogOut();
    
    this.dataToSend.pkndamanagment = data.pkndamanagment;
    this.dataToSend.fksite = Number(window.localStorage.getItem('pksite'));
    
    return this.post<boolean>('/api/NDAManagements/ChangeStatusNDAManagement', this.dataToSend);
  }

  public GetEvidencesByFKIncident(data: any) {////
    if (!this.cognitoService.IsAuhtenticated())
      this.cognitoService.LogOut();
    
    this.dataEvidenceNDAs.fkndamanagement = data.pkndamanagment;
    this.dataEvidenceNDAs.fksite = Number(window.localStorage.getItem('pksite'));
    return this.post<IEvidencesNDAs[]>('/api/Evidences/GetEvidencesByFKIncident', this.dataEvidenceNDAs);
  }

  public UpdateEvidenceNDA(data: any) { ////
     if (!this.cognitoService.IsAuhtenticated())
      this.cognitoService.LogOut();
    
    this.dataEvidenceNDAs.evidencenda = data.evidencenda;
    this.dataEvidenceNDAs.fkndamanagement = data.fkndamanagement;
    this.dataEvidenceNDAs.nameinbucket = data.nameinbucket;
    this.dataEvidenceNDAs.fksite = Number(localStorage.getItem("pksite"));
    return this.put<boolean>('/api/Evidences/UpdateEvidenceNDA', this.dataEvidenceNDAs);
  }
}
